import '../index.css'
import * as React from 'react'
import { useCallback, useEffect, useState } from 'react'
import { Avatar, Button, Divider, Statistic, Switch, Tooltip, Typography } from 'antd'
import dayjs from 'dayjs'
import { isMobile } from 'react-device-detect'
import { EyeOutlined, InfoCircleOutlined } from '@ant-design/icons'
import { formatRankStatus } from '../../../utils/formatRankStatus'
import { getLastTestDate } from '../../../utils/getLastTestDate'
//import { gql, useMutation, useQuery } from '@apollo/client'
import { PageProps } from '../'
import PanelDrawerAllergies from './panelDrawerAllergies'
import PanelDrawerMedical from './panelDrawerMedical'
import { UserService } from '../../../services/user-services'
import { UserData } from '../../../types/user/types'
import { SummaryService } from '../../../services/summary-services'

const { Text } = Typography

/*const QUERY_PATIENT = gql`
  query ($username: String!) {
    physician {
      queryPatient(username: $username) {
        firstName
        age
        birthday
        userName
        gender
        patientDetail {
          priority
          medicineAllergies {
            medicine
            allergies {
              symptom
            }
          }
          medicalConditions {
            title
            content
          }
        }
        lastActive
      }
    }
  }
`

const MUTATION_PRIORITY = gql`
  mutation ($username: String!, $toggle: Boolean!) {
    profileMutations {
      updatePatientPriority(priorityInput: { setPriority: $toggle, patientUsername: $username }) {
        status
        message {
          title
          icon
          content
        }
      }
    }
  }
`*/

const fontStyle: React.CSSProperties = {
  fontSize: '16px',
  fontWeight: 600,
}

const getAccountDisplay = (data?: UserData | null): string => {
  if (!data) return ''
  if (data.email) return data.email
  const phoneNumber = data.otherInformation?.phoneNumber
  if (phoneNumber) {
    const countryCode = data.otherInformation?.countryCode ?? ''
    return `${countryCode}${phoneNumber}`
  }
  return ''
}

/* ----------------------------------- fc ----------------------------------- */


const StatisticTitle: React.FC<{ text: string; tooltip: string }> = ({ text, tooltip }) => (
  <Tooltip title={tooltip}>
    <span style={{ cursor: 'help' }}>
      {text} <InfoCircleOutlined style={{ fontSize: 12 }} />
    </span>
  </Tooltip>
)

const PanelDivider = () => {
  if (isMobile) return <Divider type='horizontal' style={{ flexBasis: '100%', margin: '8px 0' }} />
  return <Divider type='vertical' style={{ height: '48px', margin: '0 20px' }} />
}

const Panel: React.FC<
  PageProps & {
    setReady: React.Dispatch<React.SetStateAction<boolean>>
    onPatientName?: (name: string) => void
  }
> = ({ userName, loginToken, setReady, onPatientName }) => {
  /*const { loading, data: queryData } = useQuery(QUERY_PATIENT, {
    variables: { username: userName },
    context: { headers: { Authorization: loginToken } },
  })

  useEffect(() => {
    if (!loading) {
      setReady(true)
    }
  }, [loading, setReady])

  const patientInfo = queryData?.physician?.queryPatient || null
  // if (patientInfo) console.log(11, patientInfo)
  const [isPriority, setIsPriority] = useState<boolean>(patientInfo?.patientDetail?.priority || false)

  const [togglePriority, { data: toggleData, loading: toggleLoading }] = useMutation(MUTATION_PRIORITY, {
    variables: { username: userName, toggle: !isPriority },
    context: { headers: { Authorization: loginToken } },
  })

  useEffect(() => {
    if (patientInfo?.patientDetail?.priority) {
      setIsPriority(true)
    }
  }, [patientInfo])

  useEffect(() => {
    if (toggleData?.profileMutations?.updatePatientPriority?.status) {
      setIsPriority((value) => !value)
    }
  }, [toggleData])*/

  const [userData, setUserData] = useState<UserData | null>()
  const [rank1Status, setRank1Status] = useState<string | null>()
  const [rank2Status, setRank2Status] = useState<string | null>()
  const [rank2Frailty, setRank2Frailty] = useState<string | null>()
  const userService = UserService.getInstance()
  const summaryService = SummaryService.getInstance()
  
    useEffect(() => {
        const fetchData = async () => {
          try {
            setReady(false);
            const queryUser: UserData = {
              userId: userName || '',
              email: '',
              cognition: [],
              ad8: [],
              sitToStand: [],
              nutrition: [],
              vision: [],
              hearing: [],
              mood: [],
              handgrip: [],
              exhaustion: [],
              gaitSpeed: [],
              physicalActivity: [],
              bloodPressure: [],
              creationTimestamp: '',
              lastUpdatedTimestamp: ''
            };

            const [userData, rank1Status, rank2Status, rank2Frailty] = await Promise.all([
              userService.get(queryUser),
              summaryService.getRank1(queryUser),
              summaryService.getRank2(queryUser),
              summaryService.getRank2Frailty(queryUser),
            ]);
            setUserData(userData);
            if (userData?.username) onPatientName?.(userData.username);
            setRank1Status(rank1Status);
            setRank2Status(rank2Status);
            setRank2Frailty(rank2Frailty);

          } catch (err) {
            // Handle errors
            console.error(err);
          } finally {
              setReady(true);
          }
        };
    
        // Call the async function
        fetchData();
    }, [userName, userService]);
    
  const [allergiesDrawer, setAllergiesDrawer] = useState(false)
  const [medicalDrawer, setMedicalDrawer] = useState(false)

  const showAllergiesDrawer = useCallback(() => {
    setAllergiesDrawer(true)
  }, [setAllergiesDrawer])

  const closeAllergiesDrawer = useCallback(() => {
    setAllergiesDrawer(false)
  }, [setAllergiesDrawer])

  const showMedicalDrawer = useCallback(() => {
    setMedicalDrawer(true)
  }, [setMedicalDrawer])

  const closeMedicalDrawer = useCallback(() => {
    setMedicalDrawer(false)
  }, [setMedicalDrawer])

  const lastTestDate = getLastTestDate(userData)

  return (
    <>
      {/* drawers */}
      <PanelDrawerAllergies isOpen={allergiesDrawer} closeDrawer={closeAllergiesDrawer} />
      <PanelDrawerMedical isOpen={medicalDrawer} closeDrawer={closeMedicalDrawer} />
      {/* main */}
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          justifyContent: isMobile ? 'flex-start' : 'space-between',
          alignItems: isMobile ? 'flex-start' : 'center',
          gap: 16,
          backgroundColor: '#fff',
        }}>
        {/* avatar */}
        <div className='avatar_grid'>
          <Avatar
            size={64}
            className='avatar'
            src={
              typeof userData?.userInfo === 'object' && userData?.userInfo !== null && 'sex' in userData.userInfo
                ? '/assets/icon/patient-default-avatar-' + (userData?.userInfo?.sex === 'male' ? 'blue' : 'red') + '.png'
                : '/assets/icon/patient-default-avatar-blue.png'
            }
          />
          <div className='row_flex_bottom' style={{ flexDirection: 'row', alignItems: 'baseline', gap: 12 }}>
            <Text style={{ fontSize: '22px', fontWeight: 600 }}>{userData?.username || '-'}</Text>
            {getAccountDisplay(userData) && (
              <Text type='secondary' style={{ fontSize: '14px' }}>
                {getAccountDisplay(userData)}
              </Text>
            )}
          </div>
          <Text type='secondary' style={{ fontSize: '12px' }}>
            {userData ? 'Patient' : '-'}
          </Text>
        </div>
        {/* data */}
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
          }}>
          <Statistic
            title={<StatisticTitle text='Rank 1' tooltip='Summary of the self-assessment tests: Cognition, AD8 (if required), Mobility, Nutrition, Vision, Hearing and Mood. Doing Well requires at least 4 tests Doing Well.' />}
            value={ rank1Status ? formatRankStatus(rank1Status) : '-' }
            valueStyle={fontStyle}
            style={{ flexBasis: isMobile ? '50%' : 'content' }}
          />
          <PanelDivider />
          <Statistic
            title={<StatisticTitle text='Rank 2' tooltip='Summary based on the Fried frailty phenotype score from the physical tests: Handgrip, Exhaustion, Gait Speed, Physical Activity and weight loss.' />}
            value={ rank2Status ? formatRankStatus(rank2Status) : '-' }
            valueStyle={fontStyle}
            style={{ flexBasis: isMobile ? '50%' : 'content' }}
          />
          <PanelDivider />
          <Statistic
            title={<StatisticTitle text='Frailty' tooltip='Physical frailty category from the Fried frailty phenotype score: Pre-frail (score < 3) or Frail (score >= 3).' />}
            value={ rank2Frailty ? formatRankStatus(rank2Frailty) : '-' }
            valueStyle={fontStyle}
            style={{ flexBasis: isMobile ? '50%' : 'content' }}
          />
          <PanelDivider />
          <Statistic
            title={<StatisticTitle text='Last Active' tooltip="Date of the patient's most recent test record." />}
            value={lastTestDate ? lastTestDate.format('DD MMM YYYY') : '-'}
            valueStyle={fontStyle}
            style={{ flexBasis: isMobile ? '50%' : 'content' }}
          />
          {/*<Statistic
            title='DoB'
            value={patientInfo?.birthday ? dayjs(patientInfo.birthday).format('MM / DD / YYYY') : '-'}
            valueStyle={fontStyle}
            style={{ flexBasis: isMobile ? '50%' : 'content' }}
          />
          <PanelDivider />
          <Statistic
            title='Gender'
            value={patientInfo?.gender ? (patientInfo?.gender === 'male' ? 'M' : 'F') : '-'}
            valueStyle={fontStyle}
            style={{ flexBasis: isMobile ? '100%' : 'content' }}
          />
          <PanelDivider />
          <Statistic
            title='Allergies'
            value={patientInfo?.patientDetail?.medicineAllergies?.length || 0}
            valueStyle={fontStyle}
            style={{ flexBasis: isMobile ? '100%' : 'content' }}
            formatter={(value) => {
              return (
                <div
                  className='row_flex_v_center'
                  style={{ ...fontStyle, width: isMobile ? 'calc(100vw - 32px)' : 'auto' }}>
                  {value}
                  <Button type='primary' ghost size='small' icon={<EyeOutlined />} onClick={showAllergiesDrawer}>
                    View
                  </Button>
                </div>
              )
            }}
          />
          <PanelDivider />
          <Statistic
            title='Medical Condition'
            value={patientInfo?.patientDetail?.medicalConditions?.length || 0}
            valueStyle={fontStyle}
            style={{ flexBasis: isMobile ? '100%' : 'content' }}
            formatter={(value) => {
              return (
                <div
                  className='row_flex_v_center'
                  style={{ ...fontStyle, width: isMobile ? 'calc(100vw - 32px)' : 'auto' }}>
                  {value}
                  <Button type='primary' ghost size='small' icon={<EyeOutlined />} onClick={showMedicalDrawer}>
                    View
                  </Button>
                </div>
              )
            }}
          />
          <PanelDivider />
          <Statistic
            title='Priority Queue'
            value={isPriority ? 'Yes' : 'No'}
            valueStyle={fontStyle}
            style={{ flexBasis: isMobile ? '100%' : 'content' }}
            formatter={(value) => {
              return (
                <div
                  className='row_flex_v_center'
                  style={{ ...fontStyle, width: isMobile ? 'calc(100vw - 32px)' : 'auto' }}>
                  <div>{value}</div>
                  <Switch
                    disabled={toggleLoading}
                    size='small'
                    checked={isPriority}
                    onClick={() => {
                      togglePriority()
                    }}
                  />
                </div>
              )
            }}
          />*/}
        </div>
      </div>
    </>
  )
}

export default Panel
